(async () => {
    const { Core } = await importModule('Core');
    const { $hover } = await importModule('Utils');

    customElements.define('main-navigation', class extends Core {
        elements = {
            dropdowns: '*[data-drop]'
        }
        render() {
            if(this.classList.contains("main-navigation-position-primary")){

            const nav_megaLinks_arr = this.querySelectorAll('.\\#main-navigation-list > li[data-drop] > a');
          if(nav_megaLinks_arr.length) {
 
            nav_megaLinks_arr.forEach(function (nav_link,index) {
               nav_link.addEventListener('click',function (e) {
                e.preventDefault();
                let parentEl = this.closest('li[data-drop]');
                if(parentEl) {
                  parentEl.classList.toggle('hover');
 
                  let lights_outEl = document.querySelector('lights-out');
                  if(lights_outEl) {
                    if( parentEl.classList.contains('hover')) {
                        
                        for (let sibling of parentEl.parentNode.children) {
                        if (sibling !== parentEl) sibling.classList.remove('hover');
                        }
 
                        
                      lights_outEl.setAttribute('on', '');
                    } else {
                       lights_outEl.removeAttribute('on');
                    }
                  }
                }
              });
            });
 
            document.addEventListener('click', function(e){
                var el = e.target;
                        
                if(el.tagName == 'LIGHTS-OUT') {
                if(el.hasAttribute('on')) {
                    let activeNavEl = document.querySelector('.\\#main-navigation-item.hover');
                    if(activeNavEl)  {
                    activeNavEl.classList.remove('hover');
                    el.removeAttribute('on');
                    
                    }
                }
                }
            });
           
          }

            }else{
               this.$dropdowns.map(this._handleDropdown.bind(this))
            }
           
        }
        _handleDropdown(drop) {
            $hover(drop, (e, state) => this.publish('lights-out', state));
        }
    });
})();